import AppContextProvider from './src/context'
export const wrapRootElement = AppContextProvider
